import React from 'react';

import { NavLink } from 'react-router-dom';

import { useTheme } from '@/hooks/useTheme';

/**
 * @typedef { Object } CoreNavtab
 * @property { string } link
 * @property { boolean } [exact]
 * @property { boolean } [isActive]
 * @property { (isActive: boolean) => React.ReactNode | React.ReactNode } label
 * @property { React.LazyExoticComponent<React.ComponentType<any>> } [component] - component to render for navigation tabs
 */

/**
 * @typedef { import('../Tabs').CoreTab & CoreNavtab } Navtab
 */

/**
 * @description atomic tab component for navigation
 *
 * @author  Rohit Niraj Singh <@rohit.singh3>
 *
 * @param { Navtab } props
 *
 * @returns {React.Component}
 */

const Navtab = ({ link, label, exact = true, isActive = false }) => {
	const {
		token: { colorPrimary },
	} = useTheme();
	return (
		<NavLink
			style={{
				color: isActive ? colorPrimary : '#667085', // TODO: replace with CSS var
			}}
			className={({ isActive }) => 'nav-link' + (isActive ? ' activated' : '')}
			end={exact}
			to={link}
		>
			{label instanceof Function ? label(isActive) : label}
		</NavLink>
	);
};

Navtab.displayName = 'Navtab';

export default Navtab;
